/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.13.2-49-ge91a4cf-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SSHKey interface.
 */
export function instanceOfSSHKey(value) {
    if (!('kind' in value) || value['kind'] === undefined)
        return false;
    if (!('publicKeyBase64' in value) || value['publicKeyBase64'] === undefined)
        return false;
    return true;
}
export function SSHKeyFromJSON(json) {
    return SSHKeyFromJSONTyped(json, false);
}
export function SSHKeyFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'kind': json['kind'],
        'publicKeyBase64': json['public_key_base64'],
    };
}
export function SSHKeyToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'kind': value['kind'],
        'public_key_base64': value['publicKeyBase64'],
    };
}
